import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { InputValidationView } from '@adsk/bim360-matrix-react-components';
import FormLabel from './components/FormLabel';
import { childrenType } from '../../constants/proptype-validation';
import T from "i18n-react";
import { getMandatoryFields } from "../../utils/validation-helpers";

/**
 * @class
 */
class FormField extends Component {

  /**
   * render
   */
  render() {
    const { children, className, labelText, showFieldError, infoPopoverText, container, isFieldMandatory, errorMessageText, setFieldRef } = this.props;

    const errorMessage = showFieldError ? errorMessageText : null;
    const containerClass = cx('FormField', className);
    return (
      <div ref={setFieldRef} className={containerClass} data-testid={this.props['data-testid']}>
        <div className="FormWrapper__label">
          {
            labelText && <FormLabel isFieldMandatory={isFieldMandatory}
              infoPopoverText={infoPopoverText}
              container={container}
            >
              {labelText}
            </FormLabel>
          }

        </div>
        <InputValidationView message={errorMessage}>
          {children}
        </InputValidationView>
      </div>
    );
  }
}

FormField.displayName = 'FormField';

FormField.propTypes = {
  children: childrenType.isRequired,
  labelText: PropTypes.string,
  infoPopoverText: PropTypes.string,
  container: PropTypes.object,
  showFieldError: PropTypes.bool,
  isFieldMandatory: PropTypes.bool,
  errorMessageText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  setFieldRef: PropTypes.function,
  'data-testid': PropTypes.string,
};

export function withFormField({ children, fieldName, container, selectedTransition, onChange, ...rest }) {
  const formFieldProps = {
    key: fieldName,
    labelText: T.translate(`new.${fieldName}`),
    'data-testid': `IssueCreateForm__${fieldName}`,
    container,
    isFieldMandatory: getMandatoryFields(selectedTransition).includes(fieldName),
  };

  const inputProps = {
    placeholder: T.translate(`new.placeholder.${fieldName}`),
    onChange: (newValue) => {
      const value = Array.isArray(newValue) ? newValue.map(option => option.key) : (newValue && newValue.key ? newValue.key : newValue);
      onChange(value, fieldName);
    },
  };

  return <FormField {...formFieldProps} {...rest}>
    {children(inputProps)}
  </FormField>;
}

withFormField.propTypes = {
  children: PropTypes.func,
  fieldName: PropTypes.string,
  container: PropTypes.node,
  selectedTransition: PropTypes.string,
  onChange: PropTypes.func,
};

export default FormField;
